import { render, staticRenderFns } from "./DictionariesAddResourceButton.vue?vue&type=template&id=4168d90c&"
import script from "./DictionariesAddResourceButton.vue?vue&type=script&lang=js&"
export * from "./DictionariesAddResourceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports